import { container } from './infrastructure/ioc/cc-container-configuration';
import { CC_CONTAINER_TYPES } from './infrastructure/ioc/cc-container-types';
import { CcApplicationInterface } from './infrastructure/setup/cc-application-interface';

let application = container.get<CcApplicationInterface>(CC_CONTAINER_TYPES.CcApplicationInterface);
application.run();
